/**
 * 已輸入庫存依庫編排序；同庫編以 invStockId 穩定次序。
 */
export function sortStocktakeLinesByStockNo(lines = []) {
  return [...(Array.isArray(lines) ? lines : [])].sort((left, right) => {
    const byStockNo = String(left?.stockNo ?? '').localeCompare(
      String(right?.stockNo ?? ''),
      'zh-Hant',
    );
    if (byStockNo !== 0) {
      return byStockNo;
    }
    return String(left?.invStockId ?? '').localeCompare(
      String(right?.invStockId ?? ''),
      'zh-Hant',
    );
  });
}
